// panel-styles.service.ts
import { Injectable, inject, computed, signal, effect } from '@angular/core';
import { HeightService } from '../height/height.service';

@Injectable({ providedIn: 'root' })
export class PanelStylesService {
  private heightService = inject(HeightService);

  private allStyles = signal<Record<number, string[]>>({
    84: ['84A', '84B', '84C', '84D', '84E', '84F', '84G', '84H'],
    95: ['95A', '95B', '95C', '95D', '95E', '95F', '95G', '95H', '95I', '95J', '95K', '95L', '95M', '95N', '95O', '95P'],
    108: ['108A', '108B', '108C', '108D', '108E', '108F', '108G', '108H', '108I', '108J', '108K', '108L', '108M', '108N', '108O', '108P']
  });

  readonly availableStyles = computed(() => {
    const height = this.heightService.selectedHeight();
    return height ? this.allStyles()[height] ?? [] : [];
  });

  private manualStyle = signal<string | null>(null);

  readonly selectedStyle = computed(() => {
    const manual = this.manualStyle();
    if (manual) return manual;

    const available = this.availableStyles();
    return available.length > 0 ? available[0] : null;
  });

  constructor() {
    // Reset manual style whenever height changes → ensures fallback to default
    effect(() => {
      this.heightService.selectedHeight();
      this.manualStyle.set(null);
    });
  }

  setSelectedStyle(style: string): void {
    this.manualStyle.set(style);
  }
}
